// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard_dashboard__2iGfy","container":"Dashboard_container__PPPHv"};